import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@knockrentals/knock-shared-web-v2';

const FeatureDialog = ({ children, isOpen, onClose, size = 'md', title }) => {
  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      title={title}
      size={size}
      withCloseIcon
    >
      {children}
    </Dialog>
  );
};

FeatureDialog.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  title: PropTypes.string,
};

export default FeatureDialog;
